import { createContext, useContext } from "react";
import type { WorkOrder } from "features/WorkOrders/types/work-order.types";

export type WorkOrderOverviewContextValue = {
  workOrder: WorkOrder | null;
  refetch: () => Promise<void>;
};

const WorkOrderOverviewContext =
  createContext<WorkOrderOverviewContextValue | null>(null);

export function useWorkOrderOverview() {
  const ctx = useContext(WorkOrderOverviewContext);
  if (!ctx) {
    throw new Error(
      "useWorkOrderOverview must be used within WorkOrderOverviewContext.Provider",
    );
  }
  return ctx;
}

export default WorkOrderOverviewContext;
